import React from "react";
import { Form } from "antd";
import moment from "moment";
import "moment/locale/vi";
//
//component
import DatePicker from "component/date_picker";
//redux
//selector
//actions
//utils
//hook
//str
import { locale } from "sample/locale";

moment.locale("vi");

const FormDates = ({
  name = "",
  label = undefined,
  className = "",
  placeholder = "",
  disabled = false,
  showTime = false,
  rules,
  style = {},
  initialValue = moment(),
}) => {
  // -------------------------- VAR -----------------------------

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Form.Item
      name={name}
      rules={rules}
      label={label}
      initialValue={initialValue}
      className={className}
    >
      <DatePicker
        locale={locale}
        style={{ width: "100%", ...style }}
        className="form-edit"
        placeholder={placeholder}
        disabled={disabled}
        format={"DD/MM/YYYY"}
        showTime={showTime}
      />
    </Form.Item>
  );
};
export default FormDates;
